import {useState,useEffect} from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { createTheme,ThemeProvider,Box,Button } from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useCookies } from "react-cookie";
import swal from "sweetalert";
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

let theme = createTheme({
  palette: {
    primary: {
      main: '#0052cc',
    },
    secondary: {
      main: '#1A8D90',
    },
  },
});

const ColumnForm = ({callBackAfterSubmit,companyId}) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [cookie,setCookie] = useCookies(['token'])
  const [columns,setColumns] = useState([])
  const [selectedColumns,setSelectedColumns] = useState([])
  useEffect(()=>{
        fetch(process.env.REACT_APP_BACKEND_URL+"/columns/company/"+companyId,{headers:{
            Authorization:"Bearer "+cookie['token']
        }}).then(async(data)=>{
            const jsonData = await data.json()
            setColumns(jsonData["AllColumns"].map((dt)=>dt.name))
            setSelectedColumns(jsonData["SelectedColumns"].map((dt)=>dt.name))
        })
  },[])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedColumns(
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  
  const handleFormSubmit = (e) => {
    e.preventDefault()
    fetch(process.env.REACT_APP_BACKEND_URL+"/company/columns/"+companyId,{method:"POST",headers:{
      Authorization:"Bearer "+cookie['token'],
      "Content-Type":"application/json"
    },body:JSON.stringify({"companyId":companyId,"columns":selectedColumns})}).then(async(resp)=>{
      callBackAfterSubmit()
    }).catch((e)=>{
      setCookie("token",null)
    })
  };

  return (
    <AuthGuard>
    <Box m="20px" mt={"5rem"} sx={{background:"white",width: "90%",
          maxWidth: "800px",boxSizing:"border-box",px:"1rem",zIndex:999,margin:"0 auto",borderRadius:"15px"}}>
    <Header title={"Add Specific Columns"} subtitle={"Add Specific Columns for Company"} />
    <ThemeProvider theme={theme}>
    <form onSubmit={handleFormSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                  pt:"3rem"
                }}
              >
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="demo-multiple-checkbox-label">Additional Columns</InputLabel>
                    <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={selectedColumns}
                    onChange={handleChange}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                    >
                    {columns.map((name) => (
                        <MenuItem key={name} value={name}>
                        <Checkbox checked={selectedColumns.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                        </MenuItem>
                    ))}
        </Select>
      </FormControl>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Add Columns
                </Button>
              </Box>
            </form>
</ThemeProvider>
          </Box>
    </AuthGuard>
  );
};

export default ColumnForm;
